import { render, staticRenderFns } from "./UnclearedChequeAccount.vue?vue&type=template&id=10ffec65&"
import script from "./UnclearedChequeAccount.vue?vue&type=script&lang=js&"
export * from "./UnclearedChequeAccount.vue?vue&type=script&lang=js&"
import style0 from "./UnclearedChequeAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports